module.exports = __webpack_public_path__ + "static/media/makeup.690254e7.svg";